export const Validators = {
  emailValidator: /^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i,
  stringExistsValidator: /^(?!\s*$).+$/i,
}
